<form class="theme-primary height-full" #boxImportForm="ngForm" name="boxImportForm" (submit)="import()">

	<div class="modal-header" [ngClass]="styles.dialogHeader">
		<div [ngClass]="styles.headerTitle">
			<h1 class="util-break-word" id="modal-title">
				{{ 'BoxImport' | translate }}
			</h1>
		</div>
		<div [ngClass]="styles.headerClose">
			<button type="button" class="btn float-right btn-transparent" [attr.aria-label]="'Close' | translate" (click)="closeDialog()">
				<span class="glyphicons remove_2"></span>
			</button>
		</div>
	</div>

	<div class="modal-body" [ngClass]="styles.dialogBodyWrapper">
		<div [ngClass]="styles.dialogBody">
			
			@if (isLoading) {
				<vb-loading-overlay [loadingMessage]="'Loading' | translate"></vb-loading-overlay>
			}

			@if (boxRecordings?.length ) {
				<div class="padding-top-10 padding-bottom-10">
					<span class="type-bold">{{ 'Uploads_Import_SelectVideos' | translate }}</span>
					<span class="type-bold type-14 padding-left-5">({{ 'Media_NumVideos' | translate : { '0' : boxRecordings?.length } }})</span>
					@if (this.getSelectedImports()?.length) {
						<span class="type-bold type-14 padding-left-5">({{ 'Media_BulkEdit_SelectionCount' | translate : { '0': this.getSelectedImports()?.length | number } }})</span>
					}
				</div>
			}

			@if (errorGeneric) {
				<div class="system-msg error-msg">
					<span class="glyphicons remove_2"></span>{{ 'BoxImport_NoneFound' | translate }}
				</div>
			}

			<vb-ui-data-grid [ngClass]="styles.grid" [themed]="true" [columnDefs]="gridColumnDefs" [defaultColDef]="gridDefaultColDef" [gridOptions]="gridOptions" [rowData]="boxRecordings" [rowMultiSelectWithClick]="true" [rowSelection]="'multiple'" (gridReady)="onGridReady($event)">
			</vb-ui-data-grid>

		</div>
	</div>

	<div class="modal-footer" [ngClass]="styles.dialogFooterWrapper">
		<div [ngClass]="styles.dialogFooter">
			<button type="button" class="margin-right-5" (click)="closeDialog()" vbBtnSecondary>
				{{ 'Cancel' | translate }}
			</button>
			<button type="submit" vbBtnPrimary [disabled]="boxImportForm.invalid || !this.getSelectedImports()?.length">
				{{ 'Import' | translate }}
			</button>
		</div>
	</div>

</form>
